import { render, staticRenderFns } from "./OverlayGallery.vue?vue&type=template&id=29141ee4&"
import script from "./OverlayGallery.vue?vue&type=script&lang=js&"
export * from "./OverlayGallery.vue?vue&type=script&lang=js&"
import style0 from "./OverlayGallery.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports